<template>
	<ul :class="[`tab-set justify-between fw5 f5`, $css(styles.tabset)]">
		<li v-for="(tab) in tabs" @click="onTabClick(tab.id)" :key="tab.id">
			<span
				:class="[`tab-button pr flex items-center justify-center h-100 pointer`,{active: (tab.id === activeTab)},  $css(styles.tabButton)]">
				<span class="icon">
					<img :src="buttonImages[tab.id]"/>
				</span>
				<span class="text">{{tab.label}}</span>
			</span>
		</li>
	</ul>
</template>

<script>
	import {mapState, mapActions} from "vuex";
	import consts from "@/common/consts";
	import {types} from "@/store/modules/app";
	import {getInMediaQuery as gimq, MQ_SIZES} from "@/utils/cssUtils";

	function styles() {
		return this.$style({
			tabset: gimq(
				[MQ_SIZES.D, {display: "flex"}],
				[MQ_SIZES.S, {fontSize: "12px"}]),
			tabButton: gimq(MQ_SIZES.S, {padding: "18px 5px"}),
		});
	}

	const getButtonImage = (tab, name, state) => //must use only string concat otherwise require fails
		tab === state.app.activeTab ?
			require("../../assets/images/" + name + "-active.svg") :
			require("../../assets/images/" + name + ".svg");

	export default {
		name: "Tabs",
		data() {
			return {
				tabs: [
					{id: consts.TABS.CUSTOMIZATION, label: "Customize"},
					{id: consts.TABS.PREVIEW, label: "Preview"},
					{id: consts.TABS.CODE, label: "Code"}],
			};
		},
		computed: {
			...mapState({
				activeTab: (state) => state.app.activeTab,
				buttonImages: (state) => ({
					[consts.TABS.CUSTOMIZATION]: getButtonImage(consts.TABS.CUSTOMIZATION, "customize", state),
					[consts.TABS.PREVIEW]: getButtonImage(consts.TABS.PREVIEW, "web", state),
					[consts.TABS.CODE]: getButtonImage(consts.TABS.CODE, "code", state),
				}),
			}),
			styles,
		},
		methods:{
			...mapActions("app", [types.SET_ACTIVE_TAB]),
			onTabClick(tab){
				this[types.SET_ACTIVE_TAB](tab);
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import "../../assets/scss/_variables.scss";

	.tab-set {
		line-height: 18px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
		border: 1px solid $bali;
		background: $white;
		display: none;

		li {
			flex: 1;

			.tab-button {
				padding: 18px 10px;
				color: $black;

				&:hover,
				&.active {
					color: $azure1;

					.text:after {
						display: block;
					}
				}
			}
		}

		.icon {
			margin: 0 10px 0 0;
		}

		.text {
			&:after {
				position: absolute;
				left: 0;
				right: 0;
				bottom: 0;
				height: 3px;
				content: '';
				background: $blue1;
				display: none;
			}
		}
	}
</style>
